import { decodeGppHeader } from './header.js';
export function decodeGppString(gppString) {
    const parts = gppString.split('~');
    if (parts.length < 2)
        throw new Error('Invalid GPP string (no segments)');
    const [header, ...segments] = parts;
    const dec = decodeGppHeader(header);
    return { sections: dec.sections, rawHeader: header, rawSegments: segments };
}
//# sourceMappingURL=diagnostics.js.map